export function pick<T>(obj: T, keys: string[]): T {
	if (!keys) return null;
	const result = {} as T;
	keys.forEach(key => (result[key] = obj[key]));
	return result;
}
